import { useStore } from '../store/useStore.js';

export function TimelineScrubber() {
  const history = useStore((s) => s.history);
  const historyIdx = useStore((s) => s.historyIdx);
  const jumpToHistory = useStore((s) => s.jumpToHistory);

  if (history.length <= 1) return null;

  const total = history.length;
  const current = historyIdx;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 78,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        background: 'rgba(2, 6, 20, 0.75)',
        backdropFilter: 'blur(12px)',
        border: '1px solid var(--border)',
        borderRadius: 100,
        padding: '5px 12px',
        zIndex: 79,
      }}
    >
      <span style={{ fontSize: 10, color: 'var(--muted)', marginRight: 6, whiteSpace: 'nowrap', fontFamily: 'var(--font-mono)' }}>
        {current + 1}/{total}
      </span>
      {history.map((_, i) => {
        const isCurrent = i === current;
        const isPast = i < current;
        return (
          <button
            key={i}
            title={`Ir para estado ${i + 1}`}
            onClick={() => jumpToHistory(i)}
            style={{
              width: isCurrent ? 10 : 6,
              height: isCurrent ? 10 : 6,
              borderRadius: '50%',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              flexShrink: 0,
              transition: 'all 0.15s ease',
              background: isCurrent
                ? 'var(--neon)'
                : isPast
                ? 'rgba(0,245,255,0.4)'
                : 'rgba(255,255,255,0.12)',
              boxShadow: isCurrent ? '0 0 6px var(--neon)' : 'none',
            }}
          />
        );
      })}
    </div>
  );
}
